<template>
  <div class="d-flex three-items-header">
    <div class="one-third" v-if="!isMobile">
      <slot name="item-left" />
    </div>
    <div class="one-third" :class="{ 'text-center': !isMobile }">
      <slot name="item-center" />
    </div>
    <div class="one-third right d-flex justify-end">
      <slot name="item-right" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ThreeItemsHeader"
};
</script>

<style lang="scss">
.three-items-header {
  @media only screen and (max-width: $mobile-breakpoint - 1px) {
    .one-third {
      flex-basis: 50%;
    }
  }
}
</style>
